// extracted by mini-css-extract-plugin
export default {"contentContainer":"onehub-domain-page_contentContainer__G8VCz","description1":"onehub-domain-page_description1__TGEeX","description2":"onehub-domain-page_description2__jTNYZ"};